export const sanitizeFieldProps = (props: any) => {
  const {
    label,
    record,
    source,
    labelStyle,
    applyColorTo,
    secondLabelSource,
    renderComponent,
    secondLabelRenderComponent,
    color,
    backgroundColor,
    basePath,
    labelTranslationNamespace,
    headerClassName,
    ...rest
  } = props;

  return rest;
};
